import { render, staticRenderFns } from "./MoneyCompensation.vue?vue&type=template&id=57508d2c&"
import script from "./MoneyCompensation.vue?vue&type=script&lang=js&"
export * from "./MoneyCompensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports